import React from 'react';
function Boy({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M10.075 16.218a5.916 5.916 0 01-2.465-3.53c-1.039-.014-1.454-1.032-1.454-1.72 0-.322-.005-1.7 1.032-1.718V7.94M13.925 16.217a5.916 5.916 0 002.465-3.53c1.039-.013 1.454-1.03 1.454-1.718 0-.323.005-1.7-1.032-1.72V7.94"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M9.25 15.82v.305c0 .688.206 1.699-3.572 2.406-3.99.748-3.99 3.782-3.99 3.782h20.625s0-2.977-4.27-3.782c-3.684-.694-3.637-1.718-3.637-2.406v-.247"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M7.875 17.926c.698.697 1.962 2.324 4.125 2.324 2.163 0 3.497-1.595 4.125-2.222M6.5 8.06S8.906 5.812 12 5.812s5.5 2.201 5.5 2.201"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M6.755 7.842l1.12 1.408S9.974 7.875 12 7.875s4.125 1.375 4.125 1.375l.86-1.648"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M17.156 9.317c.42-.42.344-1.304.344-1.304V5.78a2.573 2.573 0 00-1.54-2.362L12.397 1.86a.984.984 0 00-.789 0L8.045 3.418A2.578 2.578 0 006.5 5.78v2.28s-.022.917.344 1.282"
      />
    </svg>
  );
}

export default Boy;
